import { Navigate, useMatch } from "react-router";
import {
  UNIFIED_CHECKOUT_BASKET,
  UNIFIED_CHECKOUT_BASKET_OVERVIEW,
  UNIFIED_CHECKOUT_BASKET_PAY,
  UNIFIED_CHECKOUT_BASKET_SUCCESS,
} from "../../constants/routes";
import { useUnifiedCheckout } from "./UnifiedCheckoutProvider.shared";

/**
 * Redirects from /checkout/unified/:sdBasketUuid to the appropriate checkout
 * step based on the basket's payment state.
 */
export const UnifiedCheckoutIndexRedirect = () => {
  const sdBasketUuid = useMatch(UNIFIED_CHECKOUT_BASKET.pattern)?.params
    .sdBasketUuid;
  const { sdBasket, sdOrders } = useUnifiedCheckout();

  if (!sdBasketUuid) return null;

  const paidSupplierIds = sdBasket.paidSupplierIds ?? [];
  const pendingSupplierIds = sdBasket.pendingSupplierIds ?? [];
  const failedSupplierIds = sdBasket.failedSupplierIds ?? [];
  const remainingOrders = sdOrders.length;

  let targetStep: "overview" | "pay" | "success" = "overview";
  if (pendingSupplierIds.length > 0 || failedSupplierIds.length > 0) {
    targetStep = "pay";
  } else if (remainingOrders === 0 && paidSupplierIds.length > 0) {
    targetStep = "success";
  } else if (paidSupplierIds.length > 0) {
    targetStep = "pay";
  }

  const targetRoute =
    targetStep === "overview"
      ? UNIFIED_CHECKOUT_BASKET_OVERVIEW
      : targetStep === "pay"
        ? UNIFIED_CHECKOUT_BASKET_PAY
        : UNIFIED_CHECKOUT_BASKET_SUCCESS;

  return <Navigate to={targetRoute.href({ sdBasketUuid })} replace />;
};
